import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { clearedDayBookings, getAvailabilityDayBookings } from "store/availability"

/**
 * The reservations the day panel lists: one listing, one day.
 *
 * The availability feed counts a day's bookings but does not carry them, so the panel asks the
 * booking calendar's own endpoint for exactly the day it is showing — see the store thunk for why
 * it does not go through `getCalendarBookings`.
 */
export const useDayReservations = ({ listingId, date, isOpen }) => {
  const dispatch = useDispatch()

  const bookings = useSelector((state) => state.availability?.dayBookings?.list || [])
  const isLoading = useSelector((state) => Boolean(state.availability?.dayBookings?.loading))

  useEffect(() => {
    if (!isOpen || !listingId || !date) {
      dispatch(clearedDayBookings())
      return
    }
    // A URLSearchParams keeps the repeated `experience_ids[]` key the booking endpoint expects.
    const params = new URLSearchParams({ start_date: date, end_date: date })
    params.append("experience_ids[]", listingId)
    dispatch(getAvailabilityDayBookings(params)).catch(() => {})
  }, [dispatch, isOpen, listingId, date])

  return { bookings, isLoading }
}

export default useDayReservations
